export default __webpack_public_path__ + "static/media/libraryOfCongress.93164998.svg";